import { createRecipe } from './runtime';

const underlineLinkConfig = {"name":"underlineLink"}

export const underlineLink = /* @__PURE__ */ createRecipe(underlineLinkConfig)